export default "__VITE_ASSET__022ad0bc__"